import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './WsrStatusIndicator.st.css';
import Tooltip from '../Tooltip';
import { FormFieldWarningFilled, FormFieldErrorFilled, } from '@wix/wix-ui-icons-common/system';
import Loader from '../Loader';
import { dataHooks, STATUS } from './constants';
/** StatusIndicator */
class StatusIndicator extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._renderStatus = () => {
            switch (this.props.status) {
                case STATUS.WARNING:
                    return React.createElement(FormFieldWarningFilled, null);
                case STATUS.LOADING:
                    return React.createElement(Loader, { size: "tiny" });
                case STATUS.ERROR:
                default:
                    return React.createElement(FormFieldErrorFilled, null);
            }
        };
    }
    render() {
        const { dataHook, status, message, tooltipPlacement, className } = this.props;
        return (React.createElement("div", { className: st(classes.root, { status }, className), "data-hook": dataHook, "data-status": status }, message ? (React.createElement(Tooltip, { dataHook: dataHooks.tooltip, appendTo: "window", placement: tooltipPlacement, exitDelay: 100, content: message, maxWidth: 250 }, this._renderStatus())) : (this._renderStatus())));
    }
}
StatusIndicator.displayName = 'StatusIndicator';
StatusIndicator.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    status: PropTypes.oneOf(['error', 'warning', 'loading']),
    message: PropTypes.node,
    tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
};
StatusIndicator.defaultProps = {
    status: 'error',
    tooltipPlacement: 'top',
};
export default StatusIndicator;
//# sourceMappingURL=StatusIndicator.js.map